/**
 * @name LoadingTopbar
 * @description Componente común de barra de carga de Talentry
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import styled from 'styled-components';

import LoadingBar from 'react-top-loading-bar';

import { Theme } from '@styles';

class LoadingTopbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingbar: null
    };
  }

  start = () => {
    const { loadingbar } = this.state;
    loadingbar.continuousStart();
  }

  complete = () => {
    const { loadingbar } = this.state;
    loadingbar.complete();
  }

  render() {
    return (
      <Styled.LoadingBar onRef={(ref) => this.setState({ loadingbar: ref })} />
    );
  }
}

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.LoadingBar = styled(LoadingBar)`
  && {
    height: 3px;
    position: fixed !important;
    border-radius: 0 6px 6px 0;
    background-color: ${Theme.colors.purple} !important;
  }

  // Fade-out transition for the loading bar
  [class*='loading-bar-full'] {
    transition: opacity 0.35s ease-out !important;
    -moz-transition: opacity 0.35s ease-out !important;
    -webkit-transition: opacity 0.35s ease-out !important;
    -o-transition: opacity 0.35s ease-out !important;
  }
`;

export default LoadingTopbar;